module.exports = __webpack_public_path__ + "img/ch12_03_生日拥抱.dabbcbb0.jpg";